<template>
  <div>
    <ul>
      <li class="dimmed">Find me there ></li>
      <li><a href="https://www.linkedin.com/in/nidomika">LinkedIn</a></li>
      <li><a href="https://github.com/nidomika">GitHub</a></li>
      <li><a href="https://twitter.com/nidomika">Twitter</a></li>
      <li><a href="https://stackoverflow.com/users/8791668/nidomika">Stack Overflow</a></li>
    </ul>
</div>

</template>

<style scoped>
div {
  margin-top:auto;
  width: 100%;
}

ul {
  padding-inline-start: 2rem;
  margin-bottom: 0;
  padding-bottom: 32px;
}

li {
  display: inline-block;
  padding: 0.7rem;
}
li.dimmed {
  padding-left: 0;
}
</style>
